














import { Vue, Component, Prop } from 'vue-property-decorator';

import { ICustomerImportStatus } from '@/models/customer-import';

import CustomerImportWelcome from './CustomerImportWelcome.vue';
import CustomerImportProgress from './CustomerImportProgress.vue';
import CustomerImportSuccess from './CustomerImportSuccess.vue';
import CustomerImportError from './CustomerImportError.vue';

export enum EEmptyStateTabs {
  WELCOME = 0,
  PROGRESS = 1,
  SUCCESS = 2,
  ERROR = 3
}

type EmptyStateEvent = {
  type: string;
  data?: any;
};

@Component({
  components: {
    CustomerImportWelcome,
    CustomerImportProgress,
    CustomerImportError,
    CustomerImportSuccess
  }
})
export default class CustomerImportEmptyState extends Vue {
  @Prop({ default: EEmptyStateTabs.WELCOME }) defaultTab?: EEmptyStateTabs;
  @Prop() customerImportData!: ICustomerImportStatus;

  currentTab: EEmptyStateTabs = this.defaultTab as EEmptyStateTabs;
  tabs: Record<EEmptyStateTabs, string> = {
    [EEmptyStateTabs.WELCOME]: 'CustomerImportWelcome',
    [EEmptyStateTabs.PROGRESS]: 'CustomerImportProgress',
    [EEmptyStateTabs.SUCCESS]: 'CustomerImportSuccess',
    [EEmptyStateTabs.ERROR]: 'CustomerImportError'
  };

  stepProps = {};

  handleGoTo(data: { step: EEmptyStateTabs; stepProps: any }) {
    this.currentTab = data.step;
    this.stepProps = data.stepProps;
  }

  handleEvents({ type, data }: EmptyStateEvent) {
    const eventMapper: Record<string, () => void> = {
      goToCampaignCreation: () => this.$emit('import-finished', data),
      goTo: () => this.handleGoTo(data)
    };

    if (!eventMapper[type]) return;

    eventMapper[type]();
  }
}
